import React from "react";
import TextList from "../components/Typography";
import Page from '../components/Layout/Page'

function typography() {
  return (
    <Page darkNav title="Typography Shoaib alyaan">
      <TextList />
    </Page>
  );
}

export default typography;
